import { Home, Users, Wrench, FileText, DollarSign, Settings, Sparkles, Building2, Wallet, Target, ClipboardList, Link, Calendar, Sun, BarChart3, Handshake, UserPlus } from 'lucide-react';
import { theme } from '../../lib/theme';
import { getNavItems, getRoleLabel } from '../../lib/permissions';

const ICON_MAP = {
  Home, Users, Wrench, FileText, DollarSign, Settings, Sparkles,
  Building: Building2, Wallet, Target, ClipboardList, Link, Calendar, Sun, BarChart3, Handshake, UserPlus,
};

export default function Sidebar({ activeTab, setActiveTab, expanded, setExpanded, user, userRole }) {
  const role = userRole || 'broker';
  const navItems = getNavItems(role);

  const initials = user?.user_metadata?.full_name
    ? user.user_metadata.full_name.split(' ').map(n => n[0]).join('').toUpperCase()
    : 'JR';
  const displayName = user?.user_metadata?.full_name || 'Jenifer Raffa';
  const roleLabel = getRoleLabel(role);

  return (
    <div data-tour="sidebar" style={{
      width: expanded ? 220 : 60,
      height: '100vh',
      background: `linear-gradient(180deg, ${theme.colors.primaryDark} 0%, #162D50 100%)`,
      position: 'fixed',
      left: 0, top: 0,
      zIndex: 100,
      transition: 'width 0.2s ease',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    }}>
      {/* Logo */}
      <div style={{
        padding: expanded ? '16px' : '16px 13px',
        display: 'flex', alignItems: 'center', gap: 8,
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}>
        <div style={{
          width: 34, height: 34, borderRadius: 8,
          background: `linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.primaryLight})`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 800, color: 'white', fontSize: 15, flexShrink: 0,
        }}>T</div>
        {expanded && (
          <div>
            <div style={{ color: 'white', fontWeight: 700, fontSize: 14 }}>Trovva</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 9 }}>Broker Operating System</div>
          </div>
        )}
      </div>

      {/* Nav — dynamically generated from role permissions */}
      <div style={{ flex: 1, padding: '8px 4px', display: 'flex', flexDirection: 'column', gap: 2 }}>
        {navItems.map(item => {
          // Section divider
          if (item.type === 'divider') {
            return (
              <div key={item.id} style={{ padding: expanded ? '12px 12px 4px' : '10px 0 2px', }}>
                <div style={{
                  borderTop: '1px solid rgba(255,255,255,0.12)',
                  marginBottom: expanded ? 6 : 0,
                }} />
                {expanded && item.label && (
                  <div style={{
                    fontSize: 10, fontWeight: 600, textTransform: 'uppercase',
                    color: 'rgba(255,255,255,0.35)', letterSpacing: '0.08em',
                    paddingLeft: 4,
                  }}>{item.label}</div>
                )}
              </div>
            );
          }

          const active = activeTab === item.id;
          const IconComponent = ICON_MAP[item.icon] || Home;
          return (
            <button
              key={item.id}
              onClick={() => { setActiveTab(item.id); if (window.innerWidth < 768) setExpanded(false); }}
              style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '10px 12px', borderRadius: 8,
                border: 'none', cursor: 'pointer',
                backgroundColor: active ? 'rgba(255,255,255,0.14)' : 'transparent',
                color: active ? '#FFFFFF' : 'rgba(255,255,255,0.6)',
                fontSize: 13, fontWeight: active ? 600 : 400,
                borderLeft: active ? `3px solid ${theme.colors.accent}` : '3px solid transparent',
                width: '100%', textAlign: 'left',
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => { if (!active) e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)'; }}
              onMouseLeave={e => { if (!active) e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              <IconComponent size={17} style={{ flexShrink: 0 }} />
              {expanded && <span>{item.label}</span>}
            </button>
          );
        })}
      </div>

      {/* User */}
      <div style={{
        padding: expanded ? '12px 16px' : '12px',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        display: 'flex', alignItems: 'center', gap: 8,
      }}>
        <div style={{
          width: 30, height: 30, borderRadius: 15,
          background: theme.colors.accent,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontWeight: 700, fontSize: 11, flexShrink: 0,
        }}>{initials}</div>
        {expanded && (
          <div style={{ overflow: 'hidden' }}>
            <div style={{ color: 'white', fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap' }}>{displayName}</div>
            <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 10 }}>{roleLabel}</div>
          </div>
        )}
      </div>
    </div>
  );
}
